import {
  canUserDo,
  type GrafitUserWithRoles,
  isGrafitEmail,
  type Permissions,
  parseUserRoles,
} from "@grafit/shared/domain/user/user";
import { assertThat } from "@grafit/shared/utils/assert-that";
import { useAuth } from "./auth-provider";

export const useIsInternalUserOrImpersonated = (): boolean => {
  const auth = useAuth();

  return !!auth.user && isInternalUserOrImpersonated(auth.user);
};

export const useIsGrafitOnboarder = (): boolean => {
  const auth = useAuth();

  return isGrafitOnboarder(auth.user?.email);
};

const isGrafitOnboarder = (email: string | undefined): boolean => {
  if (!email) {
    return false;
  }

  return isInternalUser(email) && email.includes("onboarding");
};

export const useHasPermission = (permission: Permissions): boolean => {
  const auth = useAuth();

  return canUserDo(parseUserRoles(auth.roles), permission);
};

const isInternalUserOrImpersonated = (user: GrafitUserWithRoles): boolean => {
  // const isImpersonated: boolean = !!actor && !!actor.sub;

  return isInternalUser(user.email);
};

/** @internal (knip flags this as un necessary export since it's only imported in a test file) */
export function isInternalUser(email: string | undefined): boolean {
  if (!email) {
    return false;
  }

  return isGrafitEmail(email) && !email.includes("test");
}

export function useUserTrigram() {
  const user = useUser();
  return user.trigram;
}

export const useUser = (): GrafitUserWithRoles => {
  const auth = useAuth();
  assertThat(!!auth.user, "Expected useUser to be called when authentificated");

  return auth.user;
};
export { useAuth };
